import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { initSentry } from '@/lib/sentry'
import { devAutoLogin } from '@/lib/devAutoLogin'
import { AppErrorBoundary } from '@/components/shared/ErrorBoundary'
import App from './App.tsx'

initSentry()

// Establish a dev session (if configured) before first render — no-op in prod.
async function bootstrap() {
  await devAutoLogin()
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </StrictMode>,
  )
}

void bootstrap()
